import TeamhipSection from "../../Components/PatnershipSection/PatnershipSection";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import PageBanner from "../../layout/Banner";
import { Helmet } from "react-helmet-async";

export default function Patenrship() {
  return (
    <>
      <Helmet>
        <title>Experienced Lawyers in Delhi NCR | Our Legal Team</title>

        <meta
          name="description"
          content="Meet the accomplished legal professionals at R & P Law Partners, serving clients across Delhi NCR with practical advice and strong legal representation."
        />

        <meta name="keywords" content="Team" />

        <link rel="canonical" href="https://rplawpartners.com/team" />

        <noscript>
          Please enable JavaScript to view this page properly.
        </noscript>
      </Helmet>
      <Header />
      <PageBanner
        title="Our Team"
        subtitle="Dedicated Legal Professionals Committed to Excellence"
      />{" "}
      <TeamhipSection />
      <Footer />
    </>
  );
}
